import { Toast } from "vant";

export const mixins = {
  data() {
    return {
      urlList: [
        {
          url: "https://d10dleobq2j8xl.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-hjll.webp"),
          name: "hjll",
          time: 0,
        },
        {
          url: "https://d2a8kagkdiwm43.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-yms.webp"),
          name: "yms",
          time: 0,
        },
        {
          url: "https://d3azcu5ducn8l0.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-pornhub.webp"),
          name: "pornhub",
          time: 0,
        },
        {
          url: "https://ddqvtdnk14obd.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-llll.webp"),
          name: "lld2",
          time: 0,
        },
        {
          url: "https://d2ut4fnjpui5x4.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-haose.webp"),
          name: "haose",
          time: 0,
        },
        {
          url: "https://d328z2msc0vjzz.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-mdcm.webp"),
          name: "mdcm",
          time: 0,
        },
        {
          url: "https://d3p9c1k42quqse.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-lld.webp"),
          name: "lld",
          time: 0,
        },
        {
          url: "https://d1del3mpnc1r0d.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-bilibili.webp"),
          name: "bilibili",
          time: 0,
        },
        {
          url: "https://d3heuj0pv4x5qm.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-anwang.webp"),
          name: "anwang",
          time: 0,
        },
        {
          url: "https://domgc5wb4fyma.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-pornhub2.webp"),
          name: "pornhub2",
          time: 0,
        },
        {
          url: "https://d152ce6xp0qs98.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-xvideo.webp"),
          name: "xvideo",
          time: 0,
        },
        {
          url: "https://d3t3z4f9aj9o2d.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-boduo.webp"),
          name: "boduo",
          time: 0,
        },
        {
          url: "https://dul8dtz270h07.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-yjmh.webp"),
          name: "yjmh",
          time: 0,
        },
        {
          url: "https://dkuaif8ku3t99.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-ks.webp"),
          name: "ks",
          time: 0,
        },
        {
          url: "https://d1teyfn7xqgzc4.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-qysq.webp"),
          name: "qysq",
          time: 0,
        },
        {
          url: "https://d26wgacg89btea.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-txmh.webp"),
          name: "txmh",
          time: 0,
        },
        {
          url: "https://d1vgbn62xl21k.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-lieqi.png"),
          name: "91lq",
          time: 0,
        },
        {
          url: "https://d35cfhhrbjj2l2.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-91sm.webp"),
          name: "91sm",
          time: 0,
        },
        {
          url: "https://d1c6wubpau49xb.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-yly.webp"),
          name: "yly",
          time: 0,
        },
        {
          url: "https://d3xsqy5lfa3w0.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-tangxin.webp"),
          name: "tangxin",
          time: 0,
        },
        {
          url: "https://d275o545xun74j.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-paofu.webp"),
          name: "paofu",
          time: 0,
        },
        {
          url: "https://d3dj0ty3lcbykg.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-jljd.webp"),
          name: "jljd",
          time: 0,
        },
        {
          url: "https://d1rgq5ynjv219r.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-hls.webp"),
          name: "hls",
          time: 0,
        },
      ], // 域名数组
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
